import React, { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    Box,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Avatar,
    Menu,
    MenuItem,
    BottomNavigation,
    BottomNavigationAction,
    Paper,
} from "@mui/material";
import { Inventory2, LocalShipping, Logout } from "@mui/icons-material";

import { logoutUser, selectCurrentUser } from "../redux/slices/authSlice";
import { fetchStatusDefinitions } from "../redux/slices/statusDefinitionsSlice";
import { fetchCurrencies } from "../redux/slices/currenciesSlice";
import ColorModeToggle from "../components/common/ColorModeToggle";

const RiderLayout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const user = useSelector(selectCurrentUser);
    const [anchorEl, setAnchorEl] = React.useState(null);

    useEffect(() => {
        dispatch(fetchStatusDefinitions());
        dispatch(fetchCurrencies());
    }, [dispatch]);

    const handleLogout = () => {
        dispatch(logoutUser());
        navigate("/login");
    };

    const navValue = location.pathname.startsWith("/rider/mine") ? 1 : 0;

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", bgcolor: "background.default" }}>
            <AppBar position="static" elevation={0}>
                <Toolbar sx={{ minHeight: "56px !important", px: 2 }}>
                    <Typography variant="body1" fontWeight={700} sx={{ color: "text.primary" }}>
                        Waypoint Deliveries
                    </Typography>
                    {/* `flex={1}` as a bare prop does nothing in this MUI
                        version — see AdminLayout.jsx/CustomerLayout.jsx for
                        the full explanation; only `sx` is processed now. */}
                    <Box sx={{ flex: 1 }} />
                    <ColorModeToggle />
                    <Avatar
                        src={user?.profilePhotoUrl}
                        sx={{ width: 32, height: 32, bgcolor: "#0D629B", fontSize: 12, fontWeight: 700, cursor: "pointer" }}
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                    >
                        {user?.firstName?.[0]}
                        {user?.lastName?.[0]}
                    </Avatar>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                        <MenuItem disabled sx={{ fontSize: 13 }}>
                            {user?.firstName} {user?.lastName}
                        </MenuItem>
                        <MenuItem onClick={handleLogout} sx={{ fontSize: 13, color: "error.main" }}>
                            <Logout sx={{ mr: 1.5, fontSize: 18 }} /> Logout
                        </MenuItem>
                    </Menu>
                </Toolbar>
            </AppBar>

            <Box className="app-scroll-container" sx={{ flex: 1, overflow: "auto", p: 2 }}>
                <Box sx={{ maxWidth: 640, mx: "auto" }}>
                    <Outlet />
                </Box>
            </Box>

            <Paper elevation={3} sx={{ position: "sticky", bottom: 0 }}>
                <BottomNavigation
                    value={navValue}
                    onChange={(_, v) => navigate(v === 0 ? "/rider" : "/rider/mine")}
                    showLabels
                >
                    <BottomNavigationAction label="Available" icon={<Inventory2 />} />
                    <BottomNavigationAction label="My Deliveries" icon={<LocalShipping />} />
                </BottomNavigation>
            </Paper>
        </Box>
    );
};

export default RiderLayout;